/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./animation-color.vue?vue&type=template&id=d05cf1d8&scoped=true&"
import script from "./animation-color.vue?vue&type=script&lang=js&"
export * from "./animation-color.vue?vue&type=script&lang=js&"
import style0 from "./animation-color.vue?vue&type=style&index=0&id=d05cf1d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d05cf1d8",
  null
  
)

export default component.exports